import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import styles from "./MainApp.organisms.Product.ProductInfo.module.scss";
import MainButton from "components/MainApp/atoms/RoundedButton";
import { Grid, Modal, useTheme } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import Media from "../../Media";
import default_image from '../../../../../assets/images/default_product.png';
import HandSwipeAnimation from "shared/components/animation/hand-swipe-animation/HandSwipeAnimation";
import ProductColoursAndSize from "shared/components/retail/product-color/ProductColoursAndSize";
import { ProductService } from "services/ProductService";
import { StockService } from "services/StockService";
import CostumInput from "components/Auth/atoms/forms/InputCostum";
import { Validations } from "helpers/validations";
import SentEmailPopup from "shared/popups/sent-email-popup/SentEmailPopup";
import { isMobile } from "helpers/Mobile";
import ShareIcon from '@mui/icons-material/Share';
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const ProductInfo = ({
  product,
  productRelatedItems,
  imgCover,
  handleClickRecommended,
  historyProducts,
  onHistoryProductClick,
  showCover = false,
  videoImage,
  onClickCover,
  darkMode = false,
  screenState,
}) => {
  // const mainFilesSmall = product?.item_files ?? (product?.image ? [...product.image] : [...default_image]);

  const [mainFilesSmall, setMainFilesSmall] = useState([])
  const [mainFileBig, setMainFileBig] = useState();
  const [open, setOpen] = React.useState(false);
  const [visibleHand, setVisibleHand] = useState(false);
  const [containRetail, setContainRetail] = useState(false);
  const [retailProduct, setRetailProduct] = useState();
  const [stock, setStock] = useState(0);
  const [hasOverflow, setHasOverflow] = useState(false);
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [mail, setMail] = useState("")
  const [openSentEmailPopup, setOpenSentEmailPopup] = useState();
  const [sellPrice, setSellPrice] = useState()

  useEffect(() => {
    const divElement = document.getElementById('container-image');
    if (divElement) {
      if (divElement.scrollWidth > divElement.clientWidth) {
        setVisibleHand(true);
      }
    }
  }, [historyProducts])


  useEffect(() => {
    if (product) {

      if (containerRef.current && textRef.current) {
        setHasOverflow(textRef.current.scrollHeight > containerRef.current.clientHeight);
      }

      if (product?.item_files.length > 0) {
        setMainFilesSmall(product?.item_files)
      } else {
        setMainFilesSmall(product?.image ? [product.image] : [default_image])
      }
      setMainFileBig(mainFilesSmall?.length > 0 ? mainFilesSmall[0] : null)
      ProductService.product(product.id).then((prod) => {
        setSellPrice(prod.sell_price)
        if (prod.retail) {
          setContainRetail(true);
          setRetailProduct(prod.retail);
        } else {
          setContainRetail(false)
        }

      })

      StockService.localization_product(product.id).then((resp) => {
        setStock(resp.length);
      }).catch(() => {
        setStock(0)
      })

    } else {
      setMainFileBig(null);
      setMainFilesSmall([])
    }


  }, [product]);

  useEffect(() => {
    if (mainFilesSmall && mainFilesSmall.length > 0) {
      setMainFileBig(mainFilesSmall[0]);
    }
  }, [mainFilesSmall]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSendEmail = () => {
    setOpen(false);
    setOpenSentEmailPopup(true)
  };

  const handleCloseSentEmailPopup = () => {
    setOpenSentEmailPopup(false)
  }

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const setSelectedProduct = (sku) => {
    ProductService.itemBySKU(sku).then((prod) => {
      if (historyProducts.find(historyProd => historyProd.id === prod.id)) {
        historyProducts.push(prod.results[0])
      }
      onHistoryProductClick(prod.results[0])
    })
  }

  const getImageProduct = (product) => {
    let image = product?.item_files[0]?.file_name;
    if (!image) {
      image = product?.image ? product.image : default_image;
    }
    return image;
  }

  const handleChangeEmail = (e) => {

    setMail(e.target.value);
    if (!Validations.email(e.target.value) && e.target.value !== "") {

    }
  };

  return (
    <div className={`${styles["container-product-info"]} ${darkMode ? styles["dark"] : ""}`}>

      {showCover && videoImage && (
        <div className={`${styles["cover"]} ${darkMode ? styles["dark"] : ""}`} onClick={onClickCover}>
          {(darkMode && screenState == "ON") || !darkMode ? (
            <video autoPlay loop>
              <source src={videoImage} type="video/mp4" />
              {i18n.t("support.video.error")}
            </video>
          ) : null}
        </div>
      )}

      {product &&
        ((darkMode && screenState == "ON") || !darkMode) &&
        <div className={`${darkMode ? styles["text-white"] : ""}`}>
          {darkMode &&
            <div className={styles["detalle-prod"]}>{i18n.t("product.detail")}</div>
          }
          <Grid container>
            <Grid item xs={isMobile ? 6 : 4}>
              <div className={`${styles["column-product-info"]} ${darkMode ? styles["dark"] + " " + styles["first"] : styles["first"]}`}>

                  <div className={styles["main-image-container"]}>
                    <Media file={mainFileBig} style="image-large" controls={true} />
                  </div>

                <div className={`${styles["image-carousel"]} ${darkMode ? styles["dark"] : ""}`}>
                  {mainFilesSmall?.map((file, index) => (
                    <Media
                      key={index}
                      file={file}
                      onMouseOver={() => setMainFileBig(file)}
                    />
                  ))}
                </div>

                <div style={{ fontSize: "1.5vh" }}>{i18n.t("products.views")}</div>
                <div className={styles["container-image"]} id="container-image" onClick={() => { setVisibleHand(false); }}>

                  <div className={`${styles["image-thumbnails"]} ${darkMode ? styles["dark"] : ""}`}>
                    {historyProducts?.map((historyProduct, index) => (
                      <img
                        key={index}
                        src={getImageProduct(historyProduct)}
                        alt={`Thumbnail ${index + 1}`}
                        onClick={() => onHistoryProductClick(historyProduct)}
                      />
                    ))}
                  </div>
                  <div className={styles["hand"]}>
                    <HandSwipeAnimation visible={visibleHand}></HandSwipeAnimation>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid xs={isMobile ? 6 : 4}>
              <div className={`${styles["column-product-info"]} ${darkMode ? styles["dark"] + " " + styles["detail"] : styles["detail"]}`}>
                <div style={{ fontSize: "2vh", fontWeight: "normal", height: "4vh", marginTop: "1vh" }}>{product?.name}</div>
                <div style={{ fontSize: "1.5vh", marginTop: "0.5vh" }}>{capitalize(i18n.t("code"))}: {product?.sku}</div>
                <div style={{ marginTop: "1.5vh", fontSize: "1.5vh", display: "inline-flex" }}>
                  {stock > 0 ? <div style={{ color: "#50f757" }}>{`Stock `} </div> : <div style={{ color: "#f74242" }}>{i18n.t("out.of.stock")}</div>}
                  {stock > 0 && <div style={{ marginLeft: "5px" }}> {` (${stock} disp.)`}</div>}
                </div>
                <div ref={containerRef} className={`${styles["description-tip"]} ${hasOverflow ? styles["animate"] : ""}`}>
                  <span ref={textRef} className={styles["scroll-text"]}>{product?.description}</span>
                </div>

                <div className={styles["price"]}>
                  {sellPrice ? `${sellPrice} €` : ""}
                </div>
                {containRetail &&
                  <ProductColoursAndSize retail={retailProduct} setSelectedProduct={setSelectedProduct} />
                }


                <div className={styles["btnShare"]}>
                  <button
                    className={`${styles["main-button"]} ${styles["enabled"]}`}
                    onClick={handleOpen}
                  >
                    <ShareIcon style={{ marginRight: "10px", height: "35px", width: "35px" }} /> {i18n.t("share")}
                  </button>

                  <Modal
                    open={open}
                    // onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    <Box
                      className={`${darkMode ? styles["dark-modal"] : styles["white-modal"]}`}
                      style={{
                        position: "absolute",
                        top: "30%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "white",
                        padding: "1em",
                        maxWidth: "90%",
                        minWidth: "60%",
                        minHeight: "30%",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "20px"
                      }}
                    >
                      <h2 id="simple-modal-title">{i18n.t("enter.your.email")}</h2>

                      <CostumInput
                        style={`${darkMode ? styles["dark-style"] : ""}`}
                        id={"email"}
                        placeholder={capitalize(i18n.t("email"))}
                        icon="icon-mail"
                        handleChange={handleChangeEmail}
                      ></CostumInput>

                      <div className={styles["btnContainer"]}>
                        <span className={styles["btnCancel"]}>
                          <MainButton
                            legend={i18n.t("cancel").toUpperCase()}
                            handleClick={handleClose}
                            state={`${darkMode ? "dark-dark" : "enabled"}`}
                          />
                        </span>
                        <span className={styles["btnSend"]}>
                          <MainButton
                            legend={i18n.t("send").toUpperCase()}
                            handleClick={handleSendEmail}
                            state={`${darkMode ? "dark" : "enabled"}`}
                          />
                        </span>
                      </div>
                    </Box>
                  </Modal>
                </div>
              </div>
            </Grid>
            <Grid item xs={isMobile ? 12 : 4}>
              <div className={`${styles["column-product-info"]} ${styles["recomendation"]} ${darkMode ? styles["dark"] : ""}`}>

                <div style={{ fontSize: "1.5vh" }}>{i18n.t("recommended.products")}</div>
                <div className={styles["images-related"]}>
                  {productRelatedItems?.length > 0 &&
                    productRelatedItems.map((item, index) => (
                      <div className={`${darkMode ? styles["dark-image"] : ""}`} key={index} onClick={() => handleClickRecommended(item)}>
                        <img className={`${darkMode ? styles["dark-image"] : ""}`}
                          src={item.item_files?.[0]?.file_name}
                          alt={item.item_files?.[0]?.file_name}
                        />
                      </div>
                    ))}
                </div>

              </div>
            </Grid>
          </Grid>
        </div>
      }
      <SentEmailPopup darkMode={darkMode} open={openSentEmailPopup} handleClose={handleCloseSentEmailPopup} />
    </div>
  );
};

export default ProductInfo;
